enum ConfigurationName {
  DefaultMandatoryFields = 'defaultMandatoryFields',
  DefaultHiddenFields = 'defaultHiddenFields',
}

export default ConfigurationName
